module.exports = __webpack_public_path__ + "62ed8575475d2880ce7af1bb615b2550.jpg";